module.exports = __webpack_public_path__ + "static/media/roemmers.7bac5c8d.png";